import React from "react";
import { createStyles, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import banner from "../../../assets/banners/linkingBanner.jpg";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
    },
  }),
);

const LoginFormBanner: React.FC = () => {
  const classes = useStyles({});
  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid item>
        <img
          className={classes.root}
          src={banner}
          alt="My Warhammer"
          data-testid="loginBanner"
        />
      </Grid>
    </Grid>
  );
};
export default LoginFormBanner;
